import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { HttpService } from "./http-service";
import { Router } from "@angular/router";
import { HttpClient,  HttpHeaders} from '@angular/common/http';
import { ToastrService } from "ngx-toastr";
import { map } from "rxjs/operators";
import { Order } from "../entities/order";
import { Configuracoes } from "../entities/configuracoes";
@Injectable({
  providedIn: "root",
})
export class FreteService extends HttpService {
  constructor(
    public router: Router,
    public http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object,
    public toastService: ToastrService
  ) {
    super(http, router, toastService, platformId);
  }

  getFretesAPIAgilb2b(
    pedido: Order,
    criterioVisualizacao,
    cepDestino,
    valor,
    errorFrete,
    callback,
    formaPagamento?
  ) {
    let peso = 0;
    let medidas = "";
    pedido.itens.forEach((i) => {
      peso += i.produtoPeso;
      medidas +=
        "[" +
        (i.produtoLargura ? i.produtoLargura : 0) +
        "," +
        (i.produtoAltura ? i.produtoAltura : 0) +
        "," +
        (i.produtoComprimento ? i.produtoComprimento : 0) +
        "],";
    });
    medidas = medidas.substring(0, medidas.length - 1);
    this.showLoading();
    let url =
      Configuracoes.API +
      "frete" +
      "?cepDestino=" +
      cepDestino +
      "&id_pedido=" +
      pedido.id +
      // "&id_filial=" +
      // pedido.filial.id +
      (criterioVisualizacao !== null
        ? "&canal=" +
          criterioVisualizacao.canalFrete +
          "&tipoFrete=" +
          criterioVisualizacao.tipoFiltro
        : "") +
      "&error=" +
      (errorFrete ? "true" : "false") +
      "&formapagamento=" +
      (formaPagamento ? formaPagamento.forma_pagamento_id : "") +
      "&freteGratis=" +
      (formaPagamento ? formaPagamento.tipo_frete === "CIF" : false);
    this.http
      .get(url, this.getHttpOptionsFrete())
      .pipe(map((resp: any) => resp))
      .subscribe(
        (resp) => {
          const freteList = Array.isArray(resp?.frete) ? resp.frete : [];
          const errosList = Array.isArray(resp?.erros) ? resp.erros : [];

          let receber = freteList.filter(({ retira }) => !retira);
          let retirar = freteList.filter(({ retira }) => retira);

          for (let i = 0; i < errosList.length; i++) {
            this.toastService.error(errosList[i].erro, $localize`Frete`, {
              positionClass: "toast-bottom-left",
            });
          }

          callback({ receber, retirar });
          this.dimissLoading();
        },
        (error) => {
          this.toastService.warning($localize`Erro desconhecido`, $localize`Frete`, {
            positionClass: "toast-bottom-left",
          });
          this.dimissLoading();
        }
      );
  }

  getHttpOptionsFrete() {
    const now = Date.now()
    var header = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.getToken(),
      Branch: Configuracoes.API_BRANCH,
    });
    return {
      headers: header,
    }
  }

  getToken() {
    return window.localStorage.getItem("token");
  }
}
